var _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpark3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 50,
    viewBox: "0 0 135 50",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "0.0, 19.938834731075268 15.0, 30.69613069858468 30.0, 50.0 45.0, 23.343445745731632 60.0, 35.27585720333005 75.0, 43.31261771400177 90.0, 19.938527984490882 105.0, 0.0 120.0, 1.5644075803215913",
    fill: "none",
    stroke: "#32ca5b",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark3);
export default __webpack_public_path__ + "static/media/spark3.c58ff7da59a1e56eff9bc0132134dd20.svg";
export { ForwardRef as ReactComponent };